(function () {
  if (window.__bambooHomeLoadGuard) return;
  window.__bambooHomeLoadGuard = true;

  var pathname = window.location.pathname;
  var isHomepage = pathname === '/' || pathname === '/en';
  if (!isHomepage) return;

  var blockedPatterns = [
    /ecommplugins-scripts\.trustpilot\.com/i,
    /ecommplugins-trustboxsettings\.trustpilot\.com/i,
    /pixel\.wetracked\.io/i,
    /static\.klaviyo\.com\/onsite\/js/i,
    /extensions\.shopifycdn\.com\/cdn\/shopifycloud\/web-pixels-manager/i,
    /cdn\.shopify\.com\/extensions\/.*\/ecomsend-137\/assets\/ecomsend\.js/i,
    /cdn\.shopify\.com\/extensions\/.*\/ecomsend-137\/assets\/style\.css/i,
    /\/assets\/bamboo-popup\.js/i
  ];

  function matchesBlockedUrl(value) {
    var source = value || '';
    return blockedPatterns.some(function (pattern) {
      return pattern.test(source);
    });
  }

  function removeBlockedNode(node) {
    if (!node || node.nodeType !== 1) return false;

    var source = '';
    if (node.tagName === 'SCRIPT') {
      source = node.getAttribute('src') || '';
    } else if (node.tagName === 'LINK') {
      source = node.getAttribute('href') || '';
    }

    if (!source || !matchesBlockedUrl(source)) return false;

    node.remove();
    return true;
  }

  function purgeBlockedNodes(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    scope
      .querySelectorAll('script[src], link[rel="stylesheet"][href]')
      .forEach(function (node) {
        removeBlockedNode(node);
      });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (removeBlockedNode(node)) return;
        purgeBlockedNodes(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        purgeBlockedNodes(document);
      },
      { once: true }
    );
  } else {
    purgeBlockedNodes(document);
  }

  window.setTimeout(function () {
    observer.disconnect();
    purgeBlockedNodes(document);
  }, 8000);
})();
